__turbopack_context__.v({
  "root": "QouteBlok-module__dSQC5q__root",
});
